import module from 'module';

import './stock-item-transfer.style.less';
import templateUrl from './stock-item-transfer.template.html';
import _ from "lodash";

class StockItemTransferComponent {
  constructor(branchService, pawnItemCache, $location, pawnItemTypeCache, $route) {
    this.branchService = branchService;
    this.pawnItemCache = pawnItemCache;
    this.$location = $location;
    this.pawnItemTypeCache = pawnItemTypeCache;
    this.$route = $route;
  }

  async $onInit() {
    this.pawnItemTypes = await this.pawnItemTypeCache.toPromise();

    if (this.availableBranches && this.availableBranches.length === 1) {
      this.branch = this.availableBranches[0];
    }

    this.items = await Promise.all(
      this.itemIds.map(id => this.pawnItemCache.withParam(id).toPromise())
    );
  }

  getTypeLabel(typeId) {
    const type = _.find(this.pawnItemTypes, {id: typeId});
    return type && type.name ? type.name : '-';
  }

  cancel() {
    this.$location.path(this.cancelUrl);
    this.$route.reload();
  }

  async transfer() {
    this.onTransfer({input: {targetBranchId: this.branch.id}});
  }
}

module.component('stockItemTransfer', {
  templateUrl: templateUrl,
  bindings: {
    availableBranches: '<',
    itemIds: '<',
    onTransfer: '&',
    cancelUrl: '<'
  },
  controller: StockItemTransferComponent
});
